import type { RefObject } from 'react';
import { Control, FieldValues, Path, RegisterOptions } from 'react-hook-form';
import type Reaptcha from 'reaptcha';
import useIsCloudFlareTurnstileEnabled from '~/client/hooks/feature/useIsCloudFlareTurnstileEnabled';
import FormCloudFlareTurnstile from './FormCloudFlareTurnstile';
import FormReCAPTCHA from './FormReCAPTCHA';

type Props<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  error?: string;
  rules?: RegisterOptions;
  ref?: RefObject<Reaptcha>;
};

const FormCaptcha = <T extends FieldValues>(props: Props<T>) => {
  const isCloudFlareTurnstileEnabled = useIsCloudFlareTurnstileEnabled();
  if (isCloudFlareTurnstileEnabled) {
    return <FormCloudFlareTurnstile {...props} />;
  }
  return <FormReCAPTCHA {...props} />;
};

export default FormCaptcha;
